const createFishShape4 = shape => {
  shape.moveTo(0.502995, 9.15426);
  shape.bezierCurveTo(2.19037, 12.6367, 2.30466, 15.919, 0.21384, 20.9031);
  shape.bezierCurveTo(-0.0104812, 21.4378, 0.770461, 21.9874, 1.18872, 21.5857);
  shape.bezierCurveTo(3.41154, 19.4511, 5.38205, 17.9802, 8.54276, 16.2576);
  shape.bezierCurveTo(8.61583, 16.2178, 8.69886, 16.1965, 8.78207, 16.1965);
  shape.lineTo(10.5581, 16.1965);
  shape.bezierCurveTo(10.6481, 16.1965, 10.7375, 16.2214, 10.8149, 16.2674);
  shape.bezierCurveTo(14.9322, 18.7109, 17.569, 19.8961, 23.1759, 21.1367);
  shape.bezierCurveTo(23.3119, 21.1668, 23.4309, 21.2522, 23.5032, 21.3712);
  shape.bezierCurveTo(28.7547, 30.0183, 42.7715, 34.2011, 48.4424, 24.1105);
  shape.bezierCurveTo(48.5142, 23.9827, 48.6402, 23.8865, 48.7836, 23.8564);
  shape.bezierCurveTo(56.7607, 22.1791, 62.2967, 22.0656, 60.3937, 11.6961);
  shape.bezierCurveTo(60.3644, 11.5367, 60.257, 11.3957, 60.1094, 11.3286);
  shape.lineTo(58.7406, 10.7065);
  shape.bezierCurveTo(58.3694, 10.5377, 58.3454, 10.0195, 58.6995, 9.81715);
  shape.lineTo(58.8722, 9.71847);
  shape.bezierCurveTo(59.1576, 9.55536, 59.2096, 9.16435, 58.9701, 8.93917);
  shape.bezierCurveTo(55.8118, 5.96976, 53.0377, 5.62104, 48.0191, 5.75711);
  shape.bezierCurveTo(47.8, 5.76305, 47.6007, 5.62516, 47.5258, 5.41915);
  shape.bezierCurveTo(46.1998, 1.772, 44.7196, 1.06899, 42.3563, 0.347466);
  shape.bezierCurveTo(41.9886, 0.235199, 41.6389, 0.566942, 41.7175, 0.943296);
  shape.bezierCurveTo(42.0771, 2.66511, 42.1096, 3.81764, 41.6359, 5.42122);
  shape.bezierCurveTo(41.5746, 5.62871, 41.3816, 5.76787, 41.1652, 5.76787);
  shape.lineTo(37.9006, 5.76787);
  shape.bezierCurveTo(37.7565, 5.76787, 37.6148, 5.70025, 37.5195, 5.59225);
  shape.bezierCurveTo(31.332, -1.41801, 31.9252, 2.37445, 22.587, 8.4436);
  shape.bezierCurveTo(22.531, 8.47998, 22.465, 8.50617, 22.3993, 8.51788);
  shape.bezierCurveTo(17.0172, 9.4769, 14.0891, 10.5122, 9.07025, 12.4947);
  shape.bezierCurveTo(8.9504, 12.542, 8.81371, 12.5414, 8.69462, 12.4922);
  shape.bezierCurveTo(5.61482, 11.2191, 3.62437, 9.94919, 1.57179, 8.26209);
  shape.bezierCurveTo(1.10785, 7.88075, 0.241125, 8.61381, 0.502995, 9.15426);

  return shape;
};

export default createFishShape4;
